import { format } from 'date-fns'
import { enUS } from 'date-fns/locale'

import { useAppSelector } from '@App/hooks'
import { selectCalendarEvents } from '@App/redux/slices/calendar/selectors'
import { CalendarEvent } from '@App/redux/slices/calendar/slice'
import { Flag } from '@App/static/icons/Flags'
import { Card } from '@App/ui/crypto_exchange/desktop/components/common/Card'

import { Column, Table } from '../../../discover/components/Table'
import { ImpactIndicator } from '../Filters/components/ImpactFilter/components/ImpactIndicator'

import s from './styles.module.scss'
const formatTime = (iso: string) => format(new Date(iso), 'HH:mm')

export const formatDayHeader = (date: string | Date) => {
  const d = typeof date === 'string' ? new Date(date) : date
  return format(d, 'EEEE, MMMM d', { locale: enUS })
}

const formatMetric = (v: string | number | null, unit?: string) => {
  if (v === null || v === undefined) return '–'
  if (typeof v === 'number') return unit ? `${v}${unit}` : String(v)
  return v
}

export const Events = ({
  header,
  events,
  onRowClick,
}: {
  header?: React.ReactNode
  events: CalendarEvent[]
  onRowClick?: (event: CalendarEvent) => void
}) => {
  const columns: Column<CalendarEvent>[] = [
    {
      title: 'Time',
      key: 'datetime',
      maxWidth: '76px',
      render: (v) => <span>{formatTime(v)}</span>,
    },
    {
      title: 'Event',
      key: 'title',
      maxWidth: 'calc((100% - 180px) * 3.4 / 6.4)',
      render: (v, row) => (
        <span className={s.eventCell}>
          <Flag code={row.country.key} className={s.flagIcon} />

          <span>{v}</span>
        </span>
      ),
    },
    {
      title: 'Impact',
      key: 'impact',
      maxWidth: '104px',
      headerAlign: 'end',
      render: (v) => {
        return (
          <div className={s.flexEnd}>
            <ImpactIndicator level={v} />
          </div>
        )
      },
    },
    {
      title: 'Actual',
      key: 'metric',
      maxWidth: 'calc((100% - 180px) * 1 / 6.4)',
      headerAlign: 'end',
      render: (m) => <span className={s.flexEnd}>{formatMetric(m.actual, m.unit)}</span>,
    },
    {
      title: 'Forecast',
      key: 'metric',
      maxWidth: 'calc((100% - 180px) * 1 / 6.4)',
      headerAlign: 'end',
      render: (m) => <span className={s.flexEnd}>{formatMetric(m.forecast, m.unit)}</span>,
    },
    {
      title: 'Prior',
      key: 'metric',
      maxWidth: 'calc((100% - 180px) * 1 / 6.4)',
      headerAlign: 'end',
      render: (m) => <span className={s.flexEnd}>{formatMetric(m.prior, m.unit)}</span>,
    },
  ]

  return (
    <Card className={s.container} title={<div className={s.header}>{header}</div>}>
      <Table
        columns={columns}
        data={events}
        rowKey={(row) => row.id}
        headerSeparated={false}
        groupBy={{
          field: 'date',
          stickyHeader: true,
          renderSectionHeader: (sectionValue) => {
            return <div className={s.tableDate}>{formatDayHeader(sectionValue)}</div>
          },
        }}
        rowHoverVariant="colorized"
        bodyClassName={s.tableBody}
        onRowClick={onRowClick}
      />
    </Card>
  )
}
